module.exports = {
  "/": {
    "success": {
      "default": [
        "TODO_THIS_ALWAYS_REDIRECTS_WE_NEED_A_WAY_TO_HANDLE_THIS"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "rootView"
  },
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "bundlePage"
  },
  "/compare": {
    "success": {
      "default": [
        "COMPARE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "comparePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePage"
  },
  "/cms": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPage"
  },
  "/operations": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "operationsPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "commercePage"
  },
  "/suite": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePage"
  },
  "/splash": {
    "success": {
      "default": [
        "SPLASH_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "splashPage"
  },
  "/interstitial": {
    "success": {
      "default": [
        "INTERSTITIAL_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "interstitialPage"
  },
  "/marketing/:tab": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPagePublic"
  },
  "/sales/:tab": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPagePublic"
  },
  "/service/:tab": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePagePublic"
  },
  "/cms/:tab": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPagePublic"
  },
  "/operations/:tab": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "operationsPagePublic"
  },
  "/suite/:tab": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePagePublic"
  },
  "/splash/:tab": {
    "success": {
      "default": [
        "SPLASH_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "splashPagePublic"
  },
  "/confirm-contacts": {
    "success": {
      "default": [
        "CONTACTS_CONFIRMATION_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "confirmContactsView"
  },
  "/legacy-starter-confirmation": {
    "success": {
      "default": [
        "LEGACY_CONFIRMATION_PAGE"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ],
    "name": "legacyConfirmationView"
  },
  "/suite-starter": {
    "success": {
      "default": [
        "SUITE_STARTER_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suiteStarterPage"
  },
  "/compare-professional": {
    "success": {
      "default": [
        "COMPARE_PROFESSIONAL_PAGE"
      ]
    },
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ],
    "name": "compareProfessionalPage"
  }
};